import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { content, fetchPosts } from '../../reducers/userReducer';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const contents = [email, password];
  const login = {email, password};
  const dispatch = useDispatch();
  return (
    <div className="container d-flex flex-column align-items-center pt-3 gap-2">
      <h1 style={{fontSize:"2.2rem", color:"#3AB0FF"}}><span>Hanch</span><span style={{color:"#F39237"}}>o</span><span>r</span></h1>
      <form className="container p-4 d-flex flex-column justify-content-center gap-2">
        <h3>Quicky create an account to continue</h3>
        <div className="d-flex flex-column gap-2">
          <label>Full Name *</label>
          <input type="text" placeholder="Enter Name" className="input mb-3"/>
          <label>Email</label>
          <input type="email" placeholder="Enter Email" className="input mb-3"
            value={email}
            onChange={(e)=>{
              setEmail(e.target.value)
            }}
          ></input>
          <label>Password</label>
          <input type="password" placeholder="Enter Password" className="input mb-3"
            value={password}
            onChange={(e)=>{
              setPassword(e.target.value)
            }}
          />
          <Link to='/user' className='link'><button type="submit" className="btnS mt-4"
            onClick={()=>{
              dispatch(content(contents))
              dispatch(fetchPosts(login));
            }}
          >
            Sign Up</button>
          </Link>
        </div>
      </form>
      <p>Already have an acoount? <span className="blue-color" style={{fontWeight:"bold"}}>Login</span></p>
      <p>See what you'll experience <a target='_blank' rel="noreferrer" href='https://hanchor.netlify.app'>here</a></p>
    </div>
  );
}
